module.exports = __webpack_public_path__ + "img/cutdownPriceBg.ca0cba75.png";